<!-- 咨询记录 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="search">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item><el-input v-model="formInline.keyWord" clearable placeholder="请输入关键字"></el-input></el-form-item>
          <el-form-item><el-button type="primary" @click="()=>{ paging.page = 1;this.getList() }" icon="el-icon-search" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}">检索</el-button></el-form-item>
        </el-form>
      </div>
      <div class="tableContent">
        <el-table
          class="table"
          ref="tableData"
          :data="table.tableData"
          border
          :height="table.tableHeight"
          element-loading-text="拼命加载中,请等待"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)"
        >
          <el-table-column prop="memberId" label="用户" align="center">
            <template slot-scope="scope">
              <el-button type="text" :style="{color: $store.state.activeColor, padding:0,cursor:'pointer'}" @click="getInfo(scope.row.memberId,scope.row.memberName,scope.row.memberPortrait)">{{ scope.row.memberName }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="内容" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.content.toLowerCase().indexOf('.jpg') > -1 ||scope.row.content.toLowerCase().indexOf('.png') > -1 || scope.row.content.toLowerCase().indexOf('.jpeg') > -1 || scope.row.content.toLowerCase().indexOf('.gif') > -1">
                <el-image style="width: 100px; height: 50px;display: block;margin: 0 auto" :src="scope.row.content" fit="contain"></el-image>
              </div>
              <div v-else>{{ scope.row.content }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="messageDatetime" label="最后回复时间" align="center"></el-table-column>
        </el-table>
      </div>
      <div class="tablePagination">
        <el-pagination
          class="customPagination"
          @size-change="handlePaginationChange"
          @current-change="handlePaginationCurrentChange"
          :current-page="paging.page"
          :page-sizes="[15, 25, 50]"
          :page-size="paging.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paging.total"
        >
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'ConsultationRecord',
    data () {
      return {
        formInline: { // 查询参数
          keyWord: '' // 关键字
        },
        table: { // 表格参数
          tableData:[], // 表格数据
          tableHeight: null, // 表格高度
        },
        paging: { // 分页参数
          page: 1,// 页码
          size: 15, // 条数
          total: 0, // 总数
        },
      }
    },
    methods: {
      // 获取表格数据
      getList(){
        this.$api.searchMessage({
          page:this.paging.page,
          size:this.paging.size,
          keyword: this.formInline.keyWord
        }).then(async res => {
          if (res.data.status == 200) {
            this.table.tableData = res.data.data.records;
            this.paging.total = Number(res.data.data.total);
            for (let i = 0 ; i < this.table.tableData.length; i++){
              if (this.table.tableData[i].content.toLowerCase().indexOf('.jpg') > -1 || this.table.tableData[i].content.toLowerCase().indexOf('.png') > -1 || this.table.tableData[i].content.toLowerCase().indexOf('.jpeg') > -1 || this.table.tableData[i].content.toLowerCase().indexOf('.gif') > -1){
                this.table.tableData[i].content = api_url + "/" +this.table.tableData[i].content;
              }
              let data = await this.getMemberName(this.table.tableData[i].memberId);
              this.$set(this.table.tableData[i], "memberName", data != null ? data.name:this.table.tableData[i].memberId);
              this.$set(this.table.tableData[i], "memberPortrait", data != null ? data.portrait:'');
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 根据memberId返回名字
      async getMemberName(id){
        let data = {};
        await this.$api.findMemberById({
          id:id,
        }).then(res => {
          if (res.data.status == 200) {
            data = res.data.data;
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
        return data;
      },
      // 分页部分改变条数
      handlePaginationChange(val) {
        this.paging.size = val;
        this.paging.page = 1;
        this.getList();
      },
      // 分页部分改变页码
      handlePaginationCurrentChange(val) {
        this.paging.page = val;
        this.getList();
      },
      // 房源编号获取消息
      getInfo(memberId,memberName,memberPortrait){
        const {href} = this.$router.resolve({path: '/Message',query:{ memberId: memberId,memberName:memberName,memberPortrait:memberPortrait }})
        window.open(href,  '_blank');
      },
      // table的高度
      getTableHeight(){
        let that = this;
        if($(".table").length > 0) {
          // 表格高度初始化事件
          $(".table").height(window.innerHeight - $(".table").offset().top - 70);
          $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
          that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
          // 窗口改变事件
          window.onresize = function () { // 定义窗口大小变更通知事件
            if($(".table").length > 0) {
              $(".table").height(window.innerHeight - $(".table").offset().top - 70);
              $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
              that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
            }
          };
        }
      },
    },
    mounted() {
      // 获取页面表格高度
      this.getTableHeight();
      // 获取列表
      this.getList();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/ConsultationRecord.vue